import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
} from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import { orderStatus } from './order_status.type';
import { paymentStatus } from './payment.type';
import { useIntl } from 'react-intl';
import busOrdersApi from '../../api/bus_orders';
import CountryData from '../../utils/countrydata';

const { Option } = Select;

const BookingSMSForm = (props) => {
  const {
    isModalBookingStatus,
    setIsModalBookingStatus,
    onCloseModalBookingStatus,
    currentData,
    onRefresh,
  } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  let initialValues = {
    ...currentData,
    pay_status: currentData?.pay_status ?? null,
    order_status: currentData?.order_status ?? '',
  };
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const isMobile = window.innerWidth < 576;
  const handleOk = async () => {
    form
      .validateFields()
      .then(async (values) => {
        setIsLoadingSave(true);
        const data = {
          booking_id: currentData.id,
          company_id: currentData?.route?.operator?.id,
          phone: '+221' + form.getFieldValue('mobile'),
        };
        const res_pay = await busOrdersApi.paymentWave(data);
        if (res_pay) {
          message.success('Create booking and send SMS successfully!');
          setIsLoadingSave(false);

          onCloseModalBookingStatus();
          onRefresh();
        } else {
          message.error('send SMS fail!');
          setIsLoadingSave(false);

          onCloseModalBookingStatus();
          onRefresh();
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const onChangePayStatus = (e) => {};

  const onChangeOrderStatus = (e) => {};

  useEffect(() => {
    form.resetFields();
  }, [form]);

  return (
    <Modal
      title="Payment method: Wave"
      open={isModalBookingStatus}
      destroyOnClose={true}
      onCancel={onCloseModalBookingStatus}
      width={isMobile ? '100%' : '40%'}
      onOk={onCloseModalBookingStatus}
      footer={[
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={isLoadingSave}
          onClick={handleOk}>
          {<IntlMessage id="global.save" />}
        </Button>,
      ]}>
      <Form
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={initialValues}
        labelAlign="left"
        form={form}
        name="control-hooks"
        // style={{ maxWidth: 1000 }}
      >
        <>
          <Row gutter={[8, 8]}>
            <Col span={8}>
              <Form.Item name={'phone_code'} initialValue={'+221'}>
                <Select
                  style={{ width: '100%' }}
                  placeholder="Select phone code"
                  showSearch
                  defaultValue={`+221`}
                  options={CountryData.map((country, i) => {
                    return {
                      label: `(+${country.code}) ${country.country}`,
                      value: `+${country.code}`,
                    };
                  })}
                />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item
                name={'mobile'}
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id="global.requiredfield" />,
                  },
                  {
                    message: <IntlMessage id={`global.numberfield`} />,
                    pattern: new RegExp(/^[0-9]+$/),
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </>
      </Form>
    </Modal>
  );
};

export default BookingSMSForm;
